import { Music24JWTUser } from 'fym-common/src/db/userTypes';
import { Music24QuotaKind } from 'fym-shared/src/music24/music24Plans';
import type { UpsellSurface } from 'fym-shared/src/music24/watermarkUpsell';
import { SMLUpgradeFeature } from '../../../modules/music24/config/music24PlanCapabilities';

export interface SMLUpgradePromptStateType {
  feature: SMLUpgradeFeature;
  limit: number | null;
  used: number | null;
  kind: Music24QuotaKind | null;
  resetsAt: string | null;
  /** The song or the artist the person reached for ("Make the lyric video for Forests"). */
  subject: string | null;
  /**
   * Where the watermark offer came from (trial upsell spec 2026-10-13 §5.4): the checkout metadata
   * and the funnel events carry it. Null for every other prompt.
   */
  upsellSurface: UpsellSurface | null;
}

export interface AppInfoStateType {
  deviceId: string;
  userToken: string | null;
  userTokenDecoded: Music24JWTUser | null;
  showSMLPricingModal: boolean;
  accountId: number | null;
  isOnline: boolean;
  isServerUp: boolean;
  smlUpgradePrompt: SMLUpgradePromptStateType | null;
  /** True while the LaziiBee tour runs. The guide bar reads it on every page. */
  tourActive: boolean;
}

export const AppInfoState: AppInfoStateType = {
  deviceId: '',
  userToken: null,
  userTokenDecoded: null,
  showSMLPricingModal: false,
  accountId: null,
  isOnline: true,
  isServerUp: true,
  smlUpgradePrompt: null,
  tourActive: false,
};
